import type { ReactElement } from 'react'
import { RouterProvider } from 'react-router-dom'

import { AppProviders } from '@/components/providers/AppProviders'
import { router } from '@/routes'

export default function App(): ReactElement {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  )
}
